import styled, { css } from "styled-components";

interface IStyledImg {
  src: string;
  alt?: string;
  width?: string;
  height?: string;
  customStyle?: string;
}

const StyledImg = styled.img.attrs((props: IStyledImg) => ({
  src: props.src || "",
  alt: props.alt || "icon",
}))`
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "auto"};
  ${(props: IStyledImg) =>
    props.customStyle &&
    css`
      ${props.customStyle}
    `}
`;

export default StyledImg;
